import * as React from "react";
import { Input as InputPrimitive } from "@base-ui/react/input";

import { cn } from "~/lib/utils";
import { useShape } from "~/lib/shape-context";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  const shape = useShape();

  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "control-surface h-11 w-full min-w-0 rounded-3xl px-3.5 py-1 text-body text-foreground transition-[color,box-shadow,background-color] duration-80 outline-none file:inline-flex file:h-8 file:border-0 file:bg-transparent file:text-meta file:font-medium file:text-foreground placeholder:text-muted-foreground glider-focus-ring disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:ring-1 aria-invalid:ring-destructive/50",
        shape.input,
        className,
      )}
      {...props}
    />
  );
}

export { Input };
